import type { DrilldownNavItem } from 'client-site-chrome-ui/types/drilldownNavItem';

export enum Actions {
  GOTO_ITEM = 'GOTO_ITEM',
  GO_BACK = 'GO_BACK',
}

export const goBack = () => ({
  type: Actions.GO_BACK,
});

export const gotoItem = (item: DrilldownNavItem) => ({
  type: Actions.GOTO_ITEM,
  payload: {
    item,
  },
});

export type GotoItemAction = ReturnType<typeof gotoItem>;

export type GoBackAction = ReturnType<typeof goBack>;

export type NavigationAction = GotoItemAction | GoBackAction;
